import styled from 'styled-components'

export const ProgressBar = styled('div')`
  background-color: #e5e5e5;
  height: 4px;
  width: 100%;
  border-radius: 2px;
  overflow: hidden;
`

export const Progress = styled('div')`
  background-color: #f1f4f9;
  height: 4px;
`